module.exports = __webpack_public_path__ + "img/newcustomer_icon.1494a1da.svg";